import moment from 'moment-timezone'

import { Divider, Typography, List, ListItem } from '@mui/material'

import StyledPaper from '../paper.jsx'

const CreditBalance = ({ balance, lastPurchase, topupBundle }) => {

  const formatPrice = price => (Number(price) || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

  return (
    <>
      <div className='flex flex-row p-5'>
        <StyledPaper>
          <div className='flex flex-col gap-5 p-3 items-center w-full'>

            <Typography variant='h4'>Credit balance</Typography>

            <List sx={{width:400}}>
              {balance && <>
              <Item title="credits remaining" value={<span className='text-4xl'>{parseInt(balance.credits,10).toLocaleString()}</span>}/>
              <Item title="overdraft limit" value={parseInt(balance.overdraft,10).toLocaleString()}/>
              </>}

              {lastPurchase && <>
              <Divider/>

              <Item title="last purchased bundle" value={lastPurchase ? lastPurchase.bundle_name : "-"}/>
              <Item title="purchased" value={moment(lastPurchase.purchase_ts,"YYYYMMDDHHmmSS").format("DD MMM YYYY")}/>
              <Item title="credits puchased" value={parseInt(lastPurchase.credits,10).toLocaleString()}/>
              <Item title="price" value={"£" + parseInt(lastPurchase.price,10).toLocaleString() + (lastPurchase.vat ? ` (plus £${lastPurchase.vat} vat)` : null)}/>
              <Item title="expires" value={moment(lastPurchase.purchase_ts,"YYYYMMDDHHmmSS").add(1,"year").format("DD MMM YYYY")}/>
              </>}

              {balance && <>
              <Divider/>
              <Item title="auto top-up" value={balance.auto_topup ? "Enabled" : "Disabled"} />
              <Item
                title="auto top-up bundle"
                value={topupBundle
                  ? <>
                      {topupBundle.bundle_name}<br/>
                      {parseInt(topupBundle.credits,10).toLocaleString()} credits<br/>
                      price <span className="line-through">£{formatPrice(topupBundle.price)}</span> £{formatPrice(topupBundle.auto_price)}
                    </>
                  : "-"
                }
              />
              <Item
                title={balance.auto_topup ? "topup threshold" : "email threshold"}
                value={balance.threshold ? `${balance.threshold}% remaining` : "-"}
              />
              </>}
            </List>
          </div>
        </StyledPaper>
      </div>
    </>
  )
}

export default CreditBalance

const Item = ({ title, value }) => (
  <ListItem>
    <div className='flex flex-row w-full justify-between'>
      <div className='capitalize text-sm'>{title}</div>
      <div className='font-bold'>{value}</div>
    </div>
  </ListItem>
)
